<template>
    <div class="container-fluid text-left" style="font-size: small;">
      <div class="row">
        <div class="col-12">
          <h5>{{item.title}} Privacy policy</h5>
          <p>
            <template v-if="legalName"><strong>{{legalName}}</strong><template v-if="legalName !== item.title"><br>trade as <strong>{{item.title}}</strong></template></template>
            <template v-else><strong>{{item.title}}</strong></template>
          </p>
          <ul>
            <li>We do not share or sell personal information.</li>
            <li>The restaurant can view the name and phone number to process the order and for collection.</li>
            <li>We do not use the email or contact collected on the order page to send marketing emails.</li>
            <li>Personal information for the order is encrypted.</li>
            <li>The data stays in the UK.</li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "OrderPrivacy",
        props: {
            item: {
                type: Object,
                default: function() {
                    return {};
                }
            }
        },
        computed: {
            legalName: function() {
                var name = this.item && this.item.registeredTitle;
                if (name && String(name).length > 0) {
                    return name;
                }
                return "";
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/OrderPrivacy.vue